__turbopack_context__.v({
  "container": "CollaborationProcessCard-module-scss-module__3zQWuq__container",
  "content": "CollaborationProcessCard-module-scss-module__3zQWuq__content",
  "imageWrapper": "CollaborationProcessCard-module-scss-module__3zQWuq__imageWrapper",
  "reverse": "CollaborationProcessCard-module-scss-module__3zQWuq__reverse",
});
